import React, { useState, useEffect } from 'react';
import { services } from './serviceJson';

import Container from 'react-bootstrap/Container'
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

// Imágenes de alta calidad desde carousel
import trackit from "./img/carousel/trackit.png"
import trackit_m from "./img/carousel/trackit_m.png"
import tank from "./img/carousel/tank.png"
import tank_m from "./img/carousel/tank_m.png"
import solar from "./img/carousel/solar.png"
import solar_m from "./img/carousel/solar_m.png"
import satelital from "./img/carousel/satelital.png"
import satelital_m from "./img/carousel/satelital_m.png"
import dashcam from "./img/carousel/dashcam.png"
import dashcam_m from "./img/carousel/dashcam_m.png"
import control from "./img/carousel/control.png"
import control_m from "./img/carousel/control_m.png"

function Services({ path }) {
  const [ service, ] = useState(services[ path ])
  const [ image, setImage ] = useState('')
  const [ isMobile, setIsMobile ] = useState(false)

  // Detectar mobile y cambios de tamaño
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Cargar imagen según dispositivo
  useEffect(() => {
    const getImage = () => {
      const images = {
        trackit: isMobile ? trackit_m : trackit,
        tank: isMobile ? tank_m : tank,
        solar: isMobile ? solar_m : solar,
        satelital: isMobile ? satelital_m : satelital,
        dashcam: isMobile ? dashcam_m : dashcam,
        control: isMobile ? control_m : control
      }
      return images[path] || null
    }

    setImage(getImage())
  }, [path, isMobile])

  return (
    <div>
      <div className='parallax-conteiner'>
        {image && (
          <img
            src={image}
            className='img-100'
            alt={path}
            loading="lazy"
            decoding="async"
            fetchpriority="low"
          />
        )}
      </div>

      <div className='parallax-conteiner-mobile'>
        {image && (
          <img
            src={image}
            className='img-100'
            alt={path}
            loading="lazy"
            decoding="async"
          />
        )}
      </div>

      <div className='section-simple'>
        <Container>
          <Row>
            <Col md={8}>
              <div align="center">
                <img
                  src={service.title}
                  className='service-title'
                  alt="."
                  loading="lazy"
                />
              </div>
              <br/><br/>
              <div className='home-desc'>{service.desc}</div>
              <br/><br/><br/>
              <Container>
                <Row>
                  {service.items.map((item, index) => (
                    <Col key={index} lg={2} md={3} xs={6} align="center">
                      <div>
                        <img
                          src={item.img}
                          className='bullet-service'
                          alt={item.name}
                          loading="lazy"
                        />
                      </div>
                      <div className='bullet-text'>{item.name}</div>
                    </Col>
                  ))}
                </Row>
              </Container>
            </Col>

            <Col md={4}>
              <div align="center">
                <img
                  src={service.banner}
                  className={service.bannerClass + ' banner-mobile'}
                  alt="."
                  loading="lazy"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Services;